module.exports = __webpack_public_path__ + "img/one.26884323.png";